const QueueRandomized = require('QueueRandomized');

cc.Class({
    extends: cc.Component,

    properties: {
        sail: sp.Skeleton,
        coins: sp.Skeleton
    },

    // LIFE-CYCLE CALLBACKS:

    onLoad () {

        this.animQueue = new QueueRandomized(['motion1', 'motion2', 'motion3'], 3, 3);
        this.sail.setAnimation(0, 'idle', true);
        this.sail.setMix('idle', 'motion', 0.2);
        this.sail.setMix('motion', 'idle', 0.2);
        this.coins.setAnimation(0, 'idle', true);
        this.coins.setMix('idle', 'motion1', 0.2);
        this.coins.setMix('idle', 'motion2', 0.2);
        this.coins.setMix('idle', 'motion3', 0.2);
        this.coins.setMix('motion1', 'motion2', 0.2);
        this.coins.setMix('motion1', 'motion3', 0.2);
        this.coins.setMix('motion2', 'motion3', 0.2);
        this.coins.setMix('motion2', 'motion1', 0.2);
        this.coins.setMix('motion3', 'motion2', 0.2);
        this.coins.setMix('motion3', 'motion1', 0.2);
        this.coins.setMix('motion1', 'idle', 0.2);
        this.coins.setMix('motion2', 'idle', 0.2);
        this.coins.setMix('motion3', 'idle', 0.2);
        this.isInMotion = false;

        // this.coins.setCompleteListener(() => {
        //     switch (this.coins.animation) {
        //         // case 'idle':
        //         case 'motion1':
        //         case 'motion2':
        //         case 'motion3':
        //             this.coins.setAnimation(0, this.animQueue.getNext(), false);
        //             break;
        //     }
        // });
    },

    idle () {
        if (!this.isInMotion) {
            return;
        }

        this.isInMotion = false;
        this.sail.setAnimation(0, 'idle', true);
        this.coins.setAnimation(0, 'idle', true);
    },

    motion () {
        if (this.isInMotion) {
            return;
        }

        this.isInMotion = true;
        this.sail.setAnimation(0, 'motion', true);
        this.coins.setAnimation(0, this.animQueue.getNext(), true);
    }

    // update (dt) {},
});
